import {
    IRef,
} from './types';

import {
    useDefaultedRef,
} from 'tools/hooks';

export function useDecimalInputRef() {
    return useDefaultedRef<IRef>({
        getValue(): string | null {
            return null;
        },
        setValue(): void {
            return;
        },
        validate(): boolean {
            return true;
        },
        setError(): void {
            return;
        },
    });
}
